<template>
    <!-- <div v-if="items && items.length > 0">
        <v-list-item class="mt-3">
            <h5 class="px-2">{{ label }}</h5>
        </v-list-item>
        <v-list-item
            v-for="menu in items"
            :key="menu.title"
            link
            :to="menu.link"
            :href="menu.href"
        >
            <v-list-item-icon class="mt-4 mr-2">
                <i :class="menu.icon"></i>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
    </div> -->

    <v-list v-if="items && items.length > 0" dense nav class="submenus overflow-y-auto" v-bind:class="{ 'd-flex': horizontal}">
        <v-list-item
            v-for="(menu, index) in items"
            :key="'menu-syncs-' + index"
            :to="menu.link"
            :href="menu.href">
            <v-list-item-icon v-if="menu.icon" class="mt-4 mr-2">
                <i :class="menu.icon"></i>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        label: { type: String, default: '' },
        items: { type: Array, default: () => [] },
        horizontal: { type: Boolean, default: false }
    },


}
</script>